import React from 'react';

const NotFound = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <h1 className="text-4xl">404 - Page Not Found</h1>
    </div>
  );
};

export default NotFound;
